import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Icon, Icons } from '@ge/components/icon';
import { NAMESPACE } from '@ge/feat-analyze/models/configure-analysis-template';
import { typography } from '@ge/tokens';

import { NewAnalysisTemplateDialog } from './new-analysis-template-dialog';

const AddCaseButton = styled.button`
  color: ${(props) => props.theme.entityDetails.notes.addNote};
  display: flex;
  margin-right: 10px;
  font-weight: ${typography.weight.bold};
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
`;

const PlusIcon = styled(Icon).attrs((props) => ({
  size: 10,
  icon: Icons.ADD,
  color: props.theme.entityDetails.notes.addNote,
}))`
  flex-shrink: 0;
  margin: 1px 7px 0;
`;

export const NewAnalysisTemplateButton = () => {
  const { t, ready } = useTranslation([NAMESPACE], { useSuspense: false });

  const [showDialog, setShowDialog] = useState(false);

  if (!ready) return null;

  return (
    <>
      <AddCaseButton onClick={() => setShowDialog(true)}>
        <PlusIcon />
        {t('add_analysis_template_button', 'Add Analysis Template')}
      </AddCaseButton>
      <NewAnalysisTemplateDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        onConfirm={() => setShowDialog(false)}
      />
    </>
  );
};
